import React from 'react';
import { Box, Typography } from '@mui/material';
import { SolarPowerOutlined, ShowChart, TrendingUp } from '@mui/icons-material';
import DataLabel from './DataLabel';
import CardTemplate from '../CardTemplate';

const PHASE_COLORS = ["var(--c-brand)", "#3B82F6", "#93C5FD"];

// One row per phase, with a bar relative to the highest phase so imbalance is visible at a glance
const PhaseCurrents = ({ currents }) => {
  const max = Math.max(...currents.map(c => Math.abs(c || 0)), 1);

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-evenly", gap: 1.5 }}>
      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "var(--c-text-muted)" }}>
        Phase currents
      </Typography>
      {currents.map((current, index) => {
        const hasValue = current !== null && current !== undefined;
        return (
          <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Typography sx={{ width: 24, fontSize: 13, fontWeight: 600, color: "var(--c-text-2)" }}>
              {`L${index + 1}`}
            </Typography>
            <Box sx={{ flex: 1, height: 8, borderRadius: "999px", backgroundColor: "var(--c-muted)", overflow: "hidden" }}>
              <Box sx={{
                width: hasValue ? `${(Math.abs(current) / max) * 100}%` : 0,
                height: "100%",
                borderRadius: "999px",
                backgroundColor: PHASE_COLORS[index],
                transition: "width 400ms ease",
              }} />
            </Box>
            <Typography sx={{
              width: 64,
              textAlign: "right",
              fontSize: 15,
              fontWeight: 600,
              color: "var(--c-text)",
              fontVariantNumeric: "tabular-nums",
            }}>
              {hasValue ? `${Number(current).toFixed(0)} A` : "–"}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const CurrentCard = ({
  current1,
  current2,
  current3,
  powerAvg,
  powerMaxToday,
  energyToday,
}) => {
  return (
    <CardTemplate title="Live readings" subtitle="Latest meter values">
      <Box sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
        gap: 1.5,
      }}>
        <DataLabel
          title="Power"
          icon={<SolarPowerOutlined />}
          value={powerAvg}
          unit="kW"
          decimals={1}
        />
        <DataLabel
          title="Peak today"
          icon={<TrendingUp />}
          value={powerMaxToday}
          unit="kW"
          decimals={1}
        />
        <DataLabel
          title="Produced today"
          icon={<ShowChart />}
          value={energyToday}
          unit="kWh"
        />
      </Box>

      <PhaseCurrents currents={[current1, current2, current3]} />
    </CardTemplate>
  )
}

export default CurrentCard;
